// @ts-nocheck
// @ts-ignore
if(!customElements.get('cart-image-preview')) {
    class CartPreviewImage extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {          
            this.addEventListener('click', event => {
                this.openSimpleImagePreview(event.target.closest('cart-image-preview').dataset.previewUrl);
            })
        }
        openSimpleImagePreview(imageUrl) {
            // Open window immediately during user interaction
            const newWindow = window.open('about:blank', '_blank');
            
            if (!newWindow) {
                alert('Please allow popups for this site');
                return;
            }
            
            // Loading state
            newWindow.document.write(`
                <html>
                <head><title>Image Preview</title></head>
                <body style="margin:0;background:#000;display:flex;align-items:center;justify-content:center;height:100vh;">
                    <p style="color:#fff;font-family:system-ui;">Loading image...</p>
                </body>
                </html>
            `);
            
            // Fetch and display
            fetch(imageUrl)
                .then(response => response.blob())
                .then(blob => {
                    const blobUrl = URL.createObjectURL(blob);
                    newWindow.location.href = blobUrl;
                    newWindow.onbeforeunload = () => URL.revokeObjectURL(blobUrl);
                })
                .catch(error => {
                    console.error('Error:', error);
                    newWindow.location.href = imageUrl;
                });
        }
    }
    customElements.define('cart-image-preview', CartPreviewImage);
}